export default __webpack_public_path__ + "static/media/icon-plug.755937d8.svg";